import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layout/TheLayout.vue';

import authRouter from './modules/auth';
import settingsRoutes from './modules/settings';

Vue.use(Router);

/** note: sub-menu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 */

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its
 *                                child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    groups: ['admin','editor']    will control the page groups (you can set multiple groups)
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    [expected] noCache: true     if true, the page will no be cached(default is false)
    [expected] breadcrumb: false if false, the item will hidden in breadcrumb(default is true)
    [expected] affix: true       if true, the tag will affix in the tags-view
  }
 */

export const constantRoutes = [
  {
    path: '/',
    redirect: '/inbox',
    component: Layout,
    meta: {
      title: 'route.inbox',
      icon: 'mdi-inbox-full',
      noCache: true,
      affix: true,
    },
    children: [
      {
        path: '/inbox',
        component: () => import('@/views/components/Inbox.vue'),
        props: (route) => ({ navigationTaskId: route.query.taskId }),
        name: 'Inbox',
        meta: {
          title: 'route.inbox',
          icon: 'mdi-inbox-full',
          noCache: true,
          affix: true,
        },

      },
      {
        path: '/mass-action',
        component: () => import('@/atoms/TaskBulkAction.vue'),
        props: true,
        name: 'MassAction',
        meta: {
          title: 'route.tasks.mass-action',
          noCache: true,
          affix: true,
        },
      },
    ],
  },

  ...authRouter,
];

export default new Router({
  // mode: 'history', // gh-pages
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});

export const asyncRoutes = [

  /** When your routing table is too long, you can split it into small modules */
  // vuetifyRouter,
  // ...componentsRouter,
  {
    path: '/',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      priority: 998,
      title: 'route.tasks',
      icon: 'mdi-inbox-multiple',
      groups: ['admin', 'alltasks'],
    },
    children: [
      {
        path: '/tasks',
        component: () => import('@/views/components/Tasks.vue'),
        name: 'Tasks',
        meta: {
          groups: ['admin', 'alltasks'],
          title: 'route.tasks',
          icon: 'mdi-inbox-multiple',
          noCache: true,
          affix: true,
        },
      },
      // {
      //   path: '/processes',
      //   component: () => import('@/views/components/Processes'),
      //   name: 'Processes',
      //   meta: {
      //     groups: ['admin'],
      //     title: 'route.processes',
      //     icon: 'mdi-inbox-multiple',
      //     noCache: true,
      //     affix: true,
      //   },
      // },

      // {
      //   path: '/analytics',
      //   component: () => import('@/views/components/ProcessAnalytics'),
      //   name: 'Processes',
      //   meta: {
      //     groups: ['admin'],
      //     title: 'route.process-statistics',
      //     icon: 'mdi-inbox-multiple',
      //     noCache: true,
      //     affix: true,
      //   },
      // },
    ],
  },
  settingsRoutes,
  {
    path: '/',
    component: () => import('@/views/components/FormWebView.vue'),
    name: 'FormWebView',
    meta: {
      title: 'route.FormWebView',
    },
    children: [
      {
        path: '/task-form-view',
        component: () => import('@/views/components/FormWebView.vue'),
        name: 'FormWebViewChild',
        meta: {
          title: 'route.FormWebView',
          noCache: true,
          affix: true,
        },
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/views/components/RecordFormWebView.vue'),
    name: 'RecordFormWebView',
    meta: {
      title: 'route.RecordFormWebView',
    },
    children: [
      {
        path: '/record-form-view',
        component: () => import('@/views/components/RecordFormWebView.vue'),
        name: 'RecordFormWebViewChild',
        meta: {
          title: 'route.RecordFormWebView',
          noCache: true,
          affix: true,
        },
      },
    ],
  },
  // { path: '*', redirect: '/error/404', hidden: true },
];
